import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, ButtonComponent],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss'
})
export class VerifyEmailComponent {

  isLoading = true;
  verificationSucces = false;
  needsPassword = false;
  resetToken = '';
  errorMessage = '';
  successMessage = '';

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.verifyEmail(token);
    } else {
      this.router.navigate(['login']);
    }
  }

  goToSetPassword(): void {
    this.router.navigate(['/reset-password'], { queryParams: { token: this.resetToken } });
  }

  verifyEmail(token: string): void {
    this.errorMessage = '';
    this.successMessage = '';
    this.authService.verifyEmail(token).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.needsPassword && response.resetToken) {
          this.needsPassword = true;
          this.resetToken = response.resetToken;
          return;
        }
        this.verificationSucces = true;
      },
      (error: any) => {
        this.isLoading = false;
        this.errorMessage = error.error?.message ?? 'Error al procesar la solicitud.';
      }
    );
  }
}
